import SimpleSelect from '@/components/ui/SimpleSelect';
import { cn } from '@/lib/utils';

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50] as const;

interface PageSizeSelectProps {
  value: number;
  onValueChange?: (value: number) => void;
  options?: readonly number[];
  disabled?: boolean;
  className?: string;
  triggerClassName?: string;
  'aria-label'?: string;
}

const PageSizeSelect = ({
  value,
  onValueChange,
  options = DEFAULT_PAGE_SIZE_OPTIONS,
  disabled,
  className,
  triggerClassName,
  'aria-label': ariaLabel = 'Jumlah data per halaman',
}: PageSizeSelectProps) => {
  return (
    <SimpleSelect
      value={String(value)}
      onValueChange={(nextValue) => onValueChange?.(Number(nextValue))}
      options={options.map((size) => ({
        value: String(size),
        label: String(size),
      }))}
      disabled={disabled}
      className={className}
      triggerClassName={cn('h-8 w-auto min-w-[4rem] px-2 text-sm', triggerClassName)}
      aria-label={ariaLabel}
    />
  );
};

export default PageSizeSelect;
